import * as React from "react"

export const Width: React.FC<{
	children: React.ReactNode
	className?: string
	width?: number | string
}> = ({ children, className, width }) => {
	// Convert percentage to flex-basis
	// Width can be a number (percentage 0-100) or string like "50" or "100"
	const numericWidth = typeof width === "string" ? parseInt(width, 10) : width

	// Account for the gap (8px per side from gap-x-3 in the flex container)
	// so two 50%-width fields sit side-by-side without overflow
	const flexBasis =
		numericWidth != null ? `calc(${numericWidth}% - 16px)` : "100%"

	return (
		<div
			className={`px-3 flex-shrink-0 ${className || ""}`}
			style={{ flexBasis }}
		>
			{children}
		</div>
	)
}
